export const EASY_CLOCKING_LOGIN_LOGS_LOAD = 'EASY_CLOCKING_LOGIN_LOGS_LOAD'
export const EASY_CLOCKING_LOGIN_LOGS_LOAD_PENDING = 'EASY_CLOCKING_LOGIN_LOGS_LOAD_PENDING'
export const EASY_CLOCKING_LOGIN_LOGS_LOAD_FULFILLED = 'EASY_CLOCKING_LOGIN_LOGS_LOAD_FULFILLED'
export const EASY_CLOCKING_LOGIN_LOGS_LOAD_REJECTED = 'EASY_CLOCKING_LOGIN_LOGS_LOAD_REJECTED'

export const EASYCLOCKIN_LAST_FETCH_TIME_LOAD = 'EASYCLOCKIN_LAST_FETCH_TIME_LOAD'
export const EASYCLOCKIN_LAST_FETCH_TIME_LOAD_FULFILLED =
  'EASYCLOCKIN_LAST_FETCH_TIME_LOAD_FULFILLED'
export const EASYCLOCKIN_LAST_FETCH_TIME_LOAD_REJECTED = 'EASYCLOCKIN_LAST_FETCH_TIME_LOAD_REJECTED'
